import React from "react";
import Main from "./pages/Main";
import NavigationBar from "./components/NavigationBar";
import "./App.css";

export default function App() {
  return (
    <div>
      <NavigationBar />
      <Main />
    </div>
  );
}
